import request from '@/utils/cloud_request'
import user_cloud_request from '@/utils/user_cloud_request.js'

import crypto from '@/utils/crypto.js'

export function cloudLogin(data) {
  return request({
    url: `/manage/api/v1/login`,
    method: 'post',
    data
  })
}
// 行政区划用户信息
export function getXzqhInfo() {
  return request({
    url: `/milai/getinfo`,
    method: 'get'
  })
}

export function getInfo() {
  return request({
    url: `/user/info`,
    method: 'get'
  })
}

export function getUserQxInfo() {
  return user_cloud_request({
    url: `/milai/getInfo`,
    method: 'get'
  })
}

export function cloudRuoyiLogin(data) {
  return request({
    url: `/user/login`,
    method: 'post',
    data
  })
}

export function getImage(data) {
  // data.condition = crypto.encrypt(data.condition)
  return request({
    url: `/resource_crud2/sys_file/list`,
    method: 'post',
    data
  })
}

export function getWorkSpace(data) {
  // data.condition = crypto.encrypt(data.condition)
  return request({
    url: `/resource_crud2/sys_workspace/list`,
    method: 'post',
    data
  })
}

export function udWorkSpace(data) {
  // data.condition = crypto.encrypt(data.condition)
  return request({
    url: `/resource_crud2/sys_workspace/saveorupdate`,
    method: 'post',
    data
  })
}

export function getWayLine_file(data) {
  // data.condition = crypto.encrypt(data.condition)
  return request({
    url: `/resource_crud2/wayline_file/list`,
    method: 'post',
    data
  })
}
export function udWayLine_file(data) {
  // data.condition = crypto.encrypt(data.condition)
  return request({
    url: `/resource_crud2/wayline_file/saveorupdate`,
    method: 'post',
    data
  })
}

export function getManage_device(data) {
  // data.condition = crypto.encrypt(data.condition)
  return request({
    url: `/resource_crud2/manage_device/list`,
    method: 'post',
    data
  })
}
export function udManage_device(data) {
  // data.condition = crypto.encrypt(data.condition)
  return request({
    url: `/resource_crud2/manage_device/saveorupdate`,
    method: 'post',
    data
  })
}

// 若依临安登录
export async function getRuoyiToken(params = {}) {
  // return request.get(`/user/token/login`, params);
  return request({
    method: 'post',
    url: 'http://47.104.83.88:48080/admin-api/system/auth/login',
    data: params
  })
}
// 获取临安自己的userinfo
// export async function getUserInfo_linan(params = {}) {
//   return (await request.get(`http://192.168.3.210:48080/warning/user/info`))
//     .data
// }
